import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

const MainHeader = observer(({ children }) => {
  const [el, setEl] = useState(null);

  // The conditional should make it so this doesn't cause infinite re-renders.
  // eslint-disable-next-line
  useEffect(() => {
    const mainHeader = document.getElementById('main-header');
    if (!el && mainHeader) {
      setEl(mainHeader);
    }
  });

  if (!el) return null;
  const wrapped = <Container>{children}</Container>;
  return createPortal(wrapped, el);
});

export default MainHeader;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
`;
